import { render, staticRenderFns } from "./Tabel.vue?vue&type=template&id=37200659&"
import script from "./Tabel.vue?vue&type=script&lang=js&"
export * from "./Tabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports